module.exports = __webpack_public_path__ + "img/profile.62a12397.jpg";